export const IMAGES = {
  hero: "https://images.pexels.com/photos/33410957/pexels-photo-33410957.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  hvac: "https://images.unsplash.com/photo-1620203853151-496c7228306c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwzfHxpbmR1c3RyaWFsJTIwaHZhYyUyMHBpcGluZ3xlbnwwfHx8fDE3ODcwMjk1MDB8MA&ixlib=rb-4.1.0&q=85",
  civil: "https://images.unsplash.com/photo-1768677903496-becc4be07258?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHw0fHxjaXZpbCUyMGNvbnN0cnVjdGlvbiUyMHNpdGV8ZW58MHx8fHwxNzg3MDI5NTA5fDA&ixlib=rb-4.1.0&q=85",
  serviceCivil: "/service-civil.jpg",
  serviceHvac: "/service-hvac.jpg",
  serviceElectrical: "/service-electrical.jpg",
  servicePiping: "/service-piping.jpg",
  serviceFire: "/service-fire.jpg",
  serviceMaintenance: "/service-maintenance.jpg",
  servicePmc: "/service-pmc.jpg",
  pmc: "https://images.pexels.com/photos/358549/pexels-photo-358549.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  electrical: "https://images.pexels.com/photos/257736/pexels-photo-257736.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  piping: "https://images.unsplash.com/photo-1516937941344-00b4e0337589?q=80&w=940&auto=format&fit=crop",
  fire: "https://images.pexels.com/photos/672636/pexels-photo-672636.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  maintenance: "https://images.pexels.com/photos/1108101/pexels-photo-1108101.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  founder: "https://images.pexels.com/photos/17049771/pexels-photo-17049771.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  leader: "https://images.unsplash.com/photo-1604904612715-47bf9d9bc670?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHw0fHxjb3Jwb3JhdGUlMjBwb3J0cmFpdCUyMGFzaWFuJTIwZmVtYWxlfGVufDB8fHx8MTc4NzAyOTUwOXww&ixlib=rb-4.1.0&q=85",
  project: "https://images.unsplash.com/photo-1479839672679-a46483c0e7c8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBlbmdpbmVlcmluZyUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODcwMjk1MDB8MA&ixlib=rb-4.1.0&q=85",
  processHero: "https://images.pexels.com/photos/2383650/pexels-photo-2383650.jpeg?auto=compress&cs=tinysrgb&w=1800",
  aboutHero: "https://images.pexels.com/photos/9574399/pexels-photo-9574399.jpeg?auto=compress&cs=tinysrgb&w=1800",
};

export const VALUES = [
  "Quality Focused",
  "Safety First",
  "Innovative Solutions",
  "Client Commitment",
  "Delivering Value",
  "Engineering Excellence",
];

export const CHAPTERS = [
  {
    num: "01",
    title: "WHO WE ARE",
    heading: "Engineering expertise, built around delivery.",
    body: "VR Vision Projects & Engineering Services delivers integrated engineering and project solutions across civil, HVAC, electrical, fire protection, process and utility piping, interior solutions and project management. Our multidisciplinary approach combines technical expertise, coordinated execution and quality-driven project delivery for industrial, pharmaceutical, laboratory and commercial facilities.",
  },
  {
    num: "02",
    title: "OUR VISION",
    heading: "Engineering a Better Way Forward.",
    body: "To be a trusted engineering partner, delivering innovative, sustainable and value-driven solutions that enable better-performing industrial, pharmaceutical, laboratory and commercial facilities.",
  },
  {
    num: "03",
    title: "OUR MISSION",
    heading: "Precision in Engineering. Discipline in Delivery.",
    body: "To deliver integrated engineering, design and project management solutions through technical excellence, disciplined execution, safety and innovation — creating reliable outcomes and lasting value for our clients.",
  },
  {
    num: "04",
    title: "OUR COMMITMENT",
    heading: "Quality in Every Detail. Accountability at Every Stage.",
    body: "We are committed to delivering every project with a strong focus on quality, safety, integrity and responsible execution. Through capable people, disciplined processes and collaborative partnerships, we strive to create reliable outcomes and lasting value for our clients.",
  },
];

export const SERVICES = [
  {
    num: "01",
    icon: "Building2",
    title: "Civil & Interior Solutions",
    short: "Civil & Interior",
    desc: "End-to-end civil and interior solutions for industrial, pharmaceutical, laboratory and commercial facilities, covering civil modifications, fit-outs, finishing works and facility enhancement requirements.",
    tags: ["CIVIL CONSTRUCTION", "INDUSTRIAL FIT-OUTS", "LABORATORY & CLEANROOM FIT-OUTS", "INTERIOR FINISHES"],
    details: ["Design & Documentation", "Civil Construction & Modifications", "Industrial & Commercial Fit-Outs", "Pharma & Laboratory Fit-Outs", "Cleanroom Civil & Fit-Out Works", "Interior & Finishing Works", "Site Execution & Coordination", "Testing, Snagging & Completion"],
    image: IMAGES.serviceCivil,
  },
  {
    num: "02",
    icon: "Wind",
    title: "HVAC Engineering & Execution",
    short: "HVAC",
    desc: "Integrated HVAC solutions for industrial, pharmaceutical, laboratory and commercial facilities, covering system design, equipment selection, installation, specialized applications and performance commissioning.",
    tags: ["DESIGN & ENGINEERING", "SYSTEMS & INSTALLATION", "CLEANROOM & SPECIAL HVAC", "TESTING & COMMISSIONING"],
    details: ["HVAC Design & Engineering", "HVAC Load Calculations & Equipment Selection", "AHU, FCU & Chilled Water Systems", "VRF / VRV Systems", "Cleanroom HVAC & HEPA Filtration", "Ducting, Ventilation & Air Distribution", "HVAC Installation & System Integration", "Testing, Balancing & Commissioning"],
    image: IMAGES.serviceHvac,
  },
  {
    num: "03",
    icon: "Zap",
    title: "Electrical Works",
    short: "Electrical",
    desc: "Complete electrical design and execution with a focus on safety, quality, reliability, and timely delivery — power distribution to lighting systems.",
    tags: ["Power Distribution", "Lighting Systems", "Earthing & Protection", "Documentation"],
    details: ["Electrical Design & Load Calculations", "HT / LT Panels & Power Distribution", "Internal, External & Emergency Lighting", "Power & Control Wiring", "Earthing & Lightning Protection", "Testing, Commissioning & Handover"],
    image: IMAGES.serviceElectrical,
  },
  {
    num: "04",
    icon: "Wrench",
    title: "Process & Utility Piping",
    short: "Piping",
    desc: "Industrial process and utility piping solutions for pharmaceutical, manufacturing and process facilities, covering piping design, material selection, fabrication, installation, testing and commissioning.",
    tags: ["PROCESS PIPING", "UTILITY PIPING SYSTEMS", "SPECIALTY & CLEAN UTILITIES", "FABRICATION & INSTALLATION"],
    details: ["Process Piping Design & Engineering", "Utility Piping Systems", "Steam & Condensate", "Compressed Air & Industrial Gases", "RO & Purified Water", "Chemical & Process Media Piping", "Fabrication, Erection & Installation", "Testing & Commissioning"],
    image: IMAGES.servicePiping,
  },
  {
    num: "05",
    icon: "Flame",
    title: "Fire Protection Systems",
    short: "Fire Protection",
    desc: "Integrated fire protection solutions for pharmaceutical, industrial, laboratory and commercial facilities, covering fire water, hydrant, sprinkler, detection and alarm systems, designed and executed in accordance with applicable NBC, NFPA and project-specific safety requirements.",
    tags: ["FIRE WATER & HYDRANT SYSTEMS", "SPRINKLER & SUPPRESSION SYSTEMS", "FIRE DETECTION & ALARM", "DESIGN, INSTALLATION & COMMISSIONING"],
    details: ["Fire Protection Design & Engineering", "Fire Water Storage & Distribution", "Fire Hydrant & Hose Reel Systems", "Automatic Sprinkler Systems", "Fire Pump & Pump Room Systems", "Fire Detection & Alarm Systems", "Portable & Special Fire Suppression Systems", "Testing, Commissioning & Compliance"],
    image: IMAGES.serviceFire,
  },
  {
    num: "06",
    icon: "Settings",
    title: "Engineering Services",
    short: "Engineering Services",
    desc: "Reliable support and AMC solutions for uninterrupted performance of utility systems — chillers, compressors, AHUs, cooling towers, pumps and more.",
    tags: ["AMC Contracts", "Breakdown Support", "Energy Saving", "Spares Supply"],
    details: ["AMC for Utility Equipment", "Breakdown Support & Rectification", "Chillers, Compressors, AHUs & Pumps", "Scrubber Inspection & Services", "Genuine Spares Supply", "Energy Saving Solutions"],
    image: IMAGES.serviceMaintenance,
  },
  {
    num: "07",
    icon: "ClipboardList",
    title: "Project Management",
    short: "Project Management",
    desc: "Professional project management ensuring seamless execution with quality, time, safety, and cost efficiency — from concept to commissioning.",
    tags: ["Planning & Feasibility", "QA / QC", "Cost Control", "HSE Management"],
    details: ["Project Planning & Feasibility Study", "Design Coordination & Management", "Tendering & Vendor Management", "QA / QC & HSE Management", "Cost Control & Value Engineering", "Testing, Commissioning & Close-Out"],
    image: IMAGES.servicePmc,
  },
];

export const PROCESS = [
  {
    num: "01",
    keyword: "UNDERSTAND",
    title: "REQUIREMENT & PROJECT DISCOVERY",
    short: "Requirements, scope, site conditions and timelines.",
    desc: "We assess project requirements, operational objectives, site conditions, scope, timelines and key deliverables to establish a clear project basis.",
    details: ["Project requirements and operational objectives", "Site conditions, scope and timelines", "Key deliverables and project basis"],
  },
  {
    num: "02",
    keyword: "DEFINE",
    title: "ENGINEERING & DESIGN DEVELOPMENT",
    short: "Coordinated engineering, drawings and documentation.",
    desc: "We develop coordinated engineering solutions, drawings, specifications and project documentation aligned with technical and operational requirements.",
    details: ["Coordinated engineering solutions", "Drawings, specifications and documentation", "Technical and operational alignment"],
  },
  {
    num: "03",
    keyword: "PLAN",
    title: "PLANNING & PROJECT PREPARATION",
    short: "Methodology, schedules, resources and quality controls.",
    desc: "We establish execution methodology, procurement requirements, project schedules, resources, interfaces and quality controls before site execution.",
    details: ["Execution methodology and procurement requirements", "Project schedules, resources and interfaces", "Quality controls before site execution"],
  },
  {
    num: "04",
    keyword: "EXECUTE",
    title: "EXECUTION & COORDINATION",
    short: "Site activities, contractors, safety and schedule.",
    desc: "Our teams coordinate site activities, installations, contractors and project interfaces while maintaining quality, safety and schedule control.",
    details: ["Site activity and installation coordination", "Contractor and project interface management", "Quality, safety and schedule control"],
  },
  {
    num: "05",
    keyword: "VERIFY",
    title: "TESTING, VALIDATION & COMMISSIONING",
    short: "Testing, commissioning and operational readiness.",
    desc: "Systems and installations are inspected, tested, balanced and commissioned to verify performance and readiness for operation.",
    details: ["Inspection, testing and balancing", "Commissioning and performance verification", "Operational readiness confirmation"],
  },
  {
    num: "06",
    keyword: "DELIVER",
    title: "HANDOVER & PROJECT CLOSEOUT",
    short: "Documentation, training, closeout and handover.",
    desc: "We complete documentation, closeout activities, as-built records, training and final project requirements for a structured transition to operations.",
    details: ["Documentation and closeout activities", "As-built records and training", "Structured transition to operations"],
  },
];

export const PROCESS_PRINCIPLES = [
  { title: "PLANNED WITH PRECISION", desc: "Clear scope, defined deliverables and structured planning." },
  { title: "ENGINEERED FOR QUALITY", desc: "Technical coordination and controlled execution." },
  { title: "SAFETY & COMPLIANCE", desc: "Safety requirements embedded throughout project delivery." },
  { title: "CONTROLLED EXECUTION", desc: "Schedule, resources, interfaces and site activities actively managed." },
  { title: "DELIVERY WITH ACCOUNTABILITY", desc: "Clear ownership through testing, closeout and handover." },
];

export const TEAM = [
  {
    name: "Gangula Gopi Krishna",
    role: "Founder & Director",
    exp: "15+ Years",
    credential: "PMP® Certified",
    bio: "PMP® Certified Project Management Professional with 15+ years in multidisciplinary engineering and CAPEX project execution — from concept and planning through commissioning and close-out.",
    focus: ["Project Leadership", "Engineering Delivery", "CAPEX Execution"],
  },
  {
    name: "Anita",
    role: "Head — Design & Engineering",
    exp: "20+ Years",
    credential: "Design Leadership",
    bio: "Structural Design Engineer with 20+ years across Civil, Structural, Architectural, and Interior Design. Expert in AutoCAD, Revit, and 3D visualization, leading execution-ready documentation.",
    focus: ["Design Development", "Technical Documentation", "CAD & BIM"],
  },
];

export const PROJECTS = [
  {
    num: "01",
    client: "Resil Chemicals Pvt. Ltd.",
    sector: "Chemical & Process",
    title: "Reactor Installation & Utility Piping Modification",
    scope: ["Reactor Installation", "Utility Piping Modification", "Equipment Installation", "Commissioning Support"],
    highlights: ["Equipment and piping coordination", "Testing and commissioning support"],
    metrics: ["4 Workstreams", "Completed", "Commissioning Supported"],
    status: "Completed",
  },
  {
    num: "02",
    client: "Micro Labs Ltd.",
    sector: "Pharmaceutical Laboratory",
    title: "Laboratory Modification",
    scope: ["Laboratory Interior Modification", "Civil Works", "Utility Coordination", "Execution Support"],
    highlights: ["Civil and interior coordination", "Utility interface management"],
    metrics: ["4 Workstreams", "Completed", "Coordinated Handover"],
    status: "Completed",
  },
  {
    num: "03",
    client: "Prime Developers",
    sector: "Residential Interiors",
    title: "Interior Design & Execution",
    scope: ["Two 30×40 Residential Flats", "Space Planning", "Furniture Layout", "Interior Finishing"],
    highlights: ["Space planning and furniture coordination", "Interior finishing execution"],
    metrics: ["2 Residential Units", "Completed", "Finishing Delivered"],
    status: "Completed",
  },
  {
    num: "04",
    client: "Megloc Pvt. Ltd.",
    sector: "Corporate Training",
    title: "Project Management Skills Training",
    scope: ["Corporate PM Training", "Planning & Scheduling", "Monitoring & Control", "Operational Excellence"],
    highlights: ["Planning and scheduling sessions", "Monitoring and control framework"],
    metrics: ["4 Training Modules", "Completed", "Capability Strengthened"],
    status: "Completed",
  },
];

export const INDUSTRIES = ["Pharma & Biotech", "Chemical & Petrochemical", "Healthcare", "Commercial & Infrastructure", "Food & Beverage", "Utilities & Energy"];

export const CONTACT = {
  address: "Cycle World Building, Basement, Near Hosa Road Metro Station, Electronic City, Bengaluru — 560100",
  phone: "+91 82966 69091",
  phone2: "+91 98865 55706",
  email: "vr.visionprojectsengg@gmail.com",
  email2: "Gopi.krishna@vrvisionprojects.in",
  website: "www.visionprojects.in",
};

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Design", href: "#design" },
  { label: "Services", href: "#services-hero" },
  { label: "Process", href: "#process" },
  { label: "Leadership", href: "#leadership" },
  { label: "Projects", href: "#projects" },
  { label: "Contact", href: "#contact" },
];
